import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/posts")({
  component: lazyRouteComponent(() => import("@/pages/admin/PostList")),
});
